export default __webpack_public_path__ + "static/media/logo_RaalTrans_cmyk.9cbf7637.jpg";